import { makeVar } from "@apollo/client";
import { User } from "@/__generated__/types";
import { FilterState } from "@/components/FilterSidebar/FilterState";

export const counselorsVar = makeVar<User[] | null>(null);
export const usersVar = makeVar<User[] | null>(null);

// the state of the live filter queries on the page
export const filterStateVar = makeVar<FilterState | null>(new FilterState({}));

// sets (or resets) the initial state of the FilterSidebar form
export const initialFilterStateVar = makeVar<FilterState>(new FilterState({}));
